module.exports = [{
      plugin: require('/Users/dschau/Code/Work/gatsby/test/offline-path-prefix/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/dschau/Code/Work/gatsby/test/offline-path-prefix/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
